var alertswiper = new Swiper(".alertSwiper", {
//    direction: "vertical",
    loop: true,
    autoplay: {
        delay: 7000
    },
    effect: 'fade', fadeEffect: { crossFade: true },
});



